import React from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { useRouter } from './hooks/useRouter';
// Pages
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { RespiteCarePage } from './pages/RespiteCarePage';
import { PlanningFundingPage } from './pages/PlanningFundingPage';
import { ConciergeServicesPage } from './pages/ConciergeServicesPage';
import { InHomeCareServicesPage } from './pages/InHomeCareServicesPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { EmploymentPage } from './pages/EmploymentPage';
import { ApplicationFormPage } from './pages/ApplicationFormPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  const {
    currentRoute
  } = useRouter();
  const renderPage = () => {
    if (currentRoute === '/' || currentRoute === '') return <HomePage data-id="element-0" />;
    if (currentRoute.startsWith('/about')) return <AboutPage data-id="element-1" />;
    if (currentRoute === '/services/respite-care') return <RespiteCarePage data-id="element-2" />;
    if (currentRoute === '/services/planning-funding') return <PlanningFundingPage data-id="element-3" />;
    if (currentRoute === '/services/concierge') return <ConciergeServicesPage data-id="element-4" />;
    if (currentRoute === '/services/in-home-care') return <InHomeCareServicesPage data-id="element-5" />;
    if (currentRoute.startsWith('/services')) return <ServicesPage data-id="element-6" />;
    if (currentRoute.startsWith('/resources')) return <ResourcesPage data-id="element-7" />;
    if (currentRoute === '/application-form') return <ApplicationFormPage data-id="element-8" />;
    if (currentRoute.startsWith('/employment')) return <EmploymentPage data-id="element-9" />;
    if (currentRoute.startsWith('/testimonials')) return <TestimonialsPage data-id="element-10" />;
    if (currentRoute.startsWith('/faq')) return <FAQPage data-id="element-11" />;
    if (currentRoute.startsWith('/contact')) return <ContactPage data-id="element-12" />;
    // Fallback to home
    return <HomePage data-id="element-13" />;
  };
  return <div className="min-h-screen bg-light-alt font-sans text-dark selection:bg-primary/30 selection:text-primary-dark flex flex-col" data-id="element-14">
      <Navbar data-id="element-15" />

      <div className="flex-grow" data-id="element-16">{renderPage()}</div>

      <Footer data-id="element-17" />
    </div>;
}